import { render, staticRenderFns } from "./EModalRemanejarMatricula.vue?vue&type=template&id=6cc53930&scoped=true"
import script from "./EModalRemanejarMatricula.vue?vue&type=script&lang=js"
export * from "./EModalRemanejarMatricula.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc53930",
  null
  
)

export default component.exports